<template>
    <div class="row text-start">
        <div class="col-lg-4 checkout-content" style="min-height:250px; padding-left:30px;padding-top:10px;" :style="{'background-image': 'url(' + Store.Checkout.BackgroundImage + ')'}">
            <div class="text-start text-muted fw-bold small"><i class="bi-cart-check" style="color:black;"></i> Your Order:</div>
            <h5 style="color:black;margin-left:15px;">
                Apostille Service
            </h5>

            <div class="text-start text-muted fw-bold small"><i class="bi-cart-check" style="color:black;"></i> Order Total:</div>
            <h5 style="color:limegreen;margin-left:15px;">
                ${{ApostilleTotal.toFixed(2)}}
            </h5>


            <div class="text-center">
                <img src="/images/apostilleicon.png" style="width:50%;max-width:100px;margin-top:10px;" />
            </div>
        </div>
        <div class="col-lg-8 p-0">

            <div class="position-relative text-center p-3" style="top:5px;">

                <div class="h3 text-muted fw-semibold text-capitalize">Texas Apostille Service</div>
                <!-- Input Card -->
                <hr />
                <div class="fw-bold p-0 mb-1" style="color:limegreen">&nbsp; Once your document(s) have been completed,<br/> where should we mail them back to?</div>
                <div class="row mt-3">
                    <div class="col-md-6 text-left">
                        <div class="text-left">
                            <label style="float:left;" class="form-label mb-0">Name*</label>
                            <input v-model="Store.Checkout.Cart.ApostilleReturn.Name" type="text" class="form-control form-control-sm">
                        </div>
                    </div>
                    <div class="col-md-6 text-left">
                        <div class="text-left">
                            <label style="float:left;" class="form-label mb-0">Address 1*</label>
                            <input v-model="Store.Checkout.Cart.ApostilleReturn.Street1" type="text" class="form-control form-control-sm">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 text-left">
                        <div class="text-left">
                            <label style="float:left;" class="form-label mb-0">Address 2</label>
                            <input v-model="Store.Checkout.Cart.ApostilleReturn.Street2" type="text" class="form-control form-control-sm">
                        </div>
                    </div>
                    <div class="col-md-6 text-left">
                        <div class="text-left">
                            <label style="float:left;" class="form-label mb-0">City*</label>
                            <input v-model="Store.Checkout.Cart.ApostilleReturn.City" type="text" class="form-control form-control-sm">
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-4 text-left">
                        <div class="text-left">
                            <label style="float:left;" class="form-label mb-0">State*</label>
                            <input v-model="Store.Checkout.Cart.ApostilleReturn.State" type="text" class="form-control form-control-sm">
                        </div>
                    </div>
                    <div class="col-md-4 text-left">
                        <div class="text-left">
                            <label style="float:left;" class="form-label mb-0">Zip*</label>
                            <input v-model="Store.Checkout.Cart.ApostilleReturn.Zip" type="text" class="form-control form-control-sm">
                        </div>
                    </div>
                    <div class="col-md-4 text-left">
                        <div class="text-left">
                            <label style="float:left;" class="form-label mb-0">Country*</label>
                            <select class="form-control form-control-sm" v-model="Store.Checkout.Cart.ApostilleReturn.Country">

                                <option value="United States of America">United States of America</option>
                                <option value="Albania">Albania</option>
                                <option value="Andorra">Andorra</option>
                                <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                                <option value="Argentina">Argentina</option>
                                <option value="Armenia">Armenia</option>
                                <option value="Australia">Australia</option>
                                <option value="Austria">Austria</option>
                                <option value="Azerbaijan">Azerbaijan</option>
                                <option value="Bahamas">Bahamas</option>
                                <option value="Bahrain">Bahrain</option>
                                <option value="Barbados">Barbados</option>
                                <option value="Belgium">Belgium</option>
                                <option value="Belize">Belize</option>
                                <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                                <option value="Botswana">Botswana</option>
                                <option value="Brazil">Brazil</option>
                                <option value="Brunei Darussalam">Brunei Darussalam</option>
                                <option value="Bulgaria">Bulgaria</option>
                                <option value="Canada">Canada</option>
                                <option value="Chile">Chile</option>
                                <option value="China">China</option>
                                <option value="Colombia">Colombia</option>
                                <option value="Costa Rica">Costa Rica</option>
                                <option value="Croatia">Croatia</option>
                                <option value="Cyprus">Cyprus</option>
                                <option value="Czech Republic">Czech Republic</option>
                                <option value="Denmark">Denmark</option>
                                <option value="Dominican Republic">Dominican Republic</option>
                                <option value="Ecuador">Ecuador</option>
                                <option value="El Salvador">El Salvador</option>
                                <option value="Estonia">Estonia</option>
                                <option value="Finland">Finland</option>
                                <option value="France">France</option>
                                <option value="Georgia">Georgia</option>
                                <option value="Germany">Germany</option>
                                <option value="Greece">Greece</option>
                                <option value="Grenada">Grenada</option>
                                <option value="Hungary">Hungary</option>
                                <option value="Iceland">Iceland</option>
                                <option value="India">India</option>
                                <option value="Indonesia">Indonesia</option>
                                <option value="Ireland">Ireland</option>
                                <option value="Israel">Israel</option>
                                <option value="Italy">Italy</option>
                                <option value="Japan">Japan</option>
                                <option value="Kazakhstan">Kazakhstan</option>
                                <option value="Kenya">Kenya</option>
                                <option value="South Korea">South Korea</option>
                                <option value="Kyrgyzstan">Kyrgyzstan</option>
                                <option value="Latvia">Latvia</option>
                                <option value="Liechtenstein">Liechtenstein</option>
                                <option value="Lithuania">Lithuania</option>
                                <option value="Luxembourg">Luxembourg</option>
                                <option value="Madagascar">Madagascar</option>
                                <option value="Malawi">Malawi</option>
                                <option value="Malta">Malta</option>
                                <option value="Mexico">Mexico</option>
                                <option value="Monaco">Monaco</option>
                                <option value="Mongolia">Mongolia</option>
                                <option value="Montenegro">Montenegro</option>
                                <option value="Morocco">Morocco</option>
                                <option value="Namibia">Namibia</option>
                                <option value="Netherlands">Netherlands</option>
                                <option value="New Zealand">New Zealand</option>
                                <option value="Nicaragua">Nicaragua</option>
                                <option value="Norway">Norway</option>
                                <option value="Oman">Oman</option>
                                <option value="Panama">Panama</option>
                                <option value="Peru">Peru</option>
                                <option value="Philippines">Philippines</option>
                                <option value="Poland">Poland</option>
                                <option value="Portugal">Portugal</option>
                                <option value="Romania">Romania</option>
                                <option value="Russia">Russia</option>
                                <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                                <option value="Saint Lucia">Saint Lucia</option>
                                <option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
                                <option value="San Marino">San Marino</option>
                                <option value="Serbia">Serbia</option>
                                <option value="Slovakia">Slovakia</option>
                                <option value="Slovenia">Slovenia</option>
                                <option value="South Africa">South Africa</option>
                                <option value="Spain">Spain</option>
                                <option value="Suriname">Suriname</option>
                                <option value="Sweden">Sweden</option>
                                <option value="Switzerland">Switzerland</option>
                                <option value="Tajikistan">Tajikistan</option>
                                <option value="Tanzania">Tanzania</option>
                                <option value="Thailand">Thailand</option>
                                <option value="Turkey">Turkey</option>
                                <option value="Ukraine">Ukraine</option>
                                <option value="United Arab Emirates">United Arab Emirates</option>
                                <option value="Uruguay">Uruguay</option>
                                <option value="Uzbekistan">Uzbekistan</option>
                                <option value="Venezuela">Venezuela</option>
                                <option value="Vietnam">Vietnam</option>
                            </select>                            
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="blink text-red fw-bold text-center mt-2" v-if="AddressError">{{AddressError}}</div>
                    </div>
                </div>

                <hr />
                <div class="fw-bold p-0 mb-1" style="color:limegreen">&nbsp; How many documents, i.e. signatures do you<br/>need authenticated via Texas State Apostille?</div>
                <select class="form-control form-control-sm text-center shadow-sm" v-model.number="Store.Checkout.Cart.NumApostilleItems">
                    <option :val="1">1</option>
                    <option :val="2">2</option>
                    <option :val="3">3</option>
                    <option :val="4">4</option>
                    <option :val="5">5</option>
                    <option :val="6">6</option>
                    <option :val="7">7</option>
                    <option :val="8">8</option>
                    <option :val="9">9</option>
                    <option :val="10">10</option>
                </select>
                <hr />
                <div class="fw-bold p-0 mb-1" style="color:limegreen">&nbsp; Select Your Desired Service Speed</div>
                <!-- End Input Card -->
                <table style="width:100%">
                    <tr>
                        <!-- Standard -->
                        <td :class="Store.Checkout.Cart.ServiceSpeed == 0? 'shadow':''">
                            <input v-model="Store.Checkout.Cart.ServiceSpeed" :value="0" type="radio" class="btn-check" name="btnradio" id='option1' autocomplete="off">
                            <label style="width:100%" class="btn btn-outline-primary shadow-sm" for="option1">
                                Standard Service<br>
                                <span style="font-size:12px" class="fw-light">
                                    ${{ApostilleConfig.basicFee.toFixed(2)}} first document<br />
                                    ${{ApostilleConfig.basicFeeAdditionalDocument.toFixed(2)}} each additional
                                </span>
                            </label>
                        </td>

                        <!-- Express (if allowed) -->
                        <td :class="Store.Checkout.Cart.ServiceSpeed == 1? 'shadow':''" v-if="ApostilleConfig.offerExpressService">
                            <input v-model="Store.Checkout.Cart.ServiceSpeed" :value="1" type="radio" class="btn-check" name="btnradio" id="option2" autocomplete="off">
                            <label style="width:100%" class="btn btn-outline-primary shadow-sm" for="option2">
                                Express Service<br>
                                <span style="font-size:12px" class="fw-light">
                                    ${{ApostilleConfig.expeditedFee.toFixed(2)}} first document<br />
                                    ${{ApostilleConfig.expeditedFeeAdditionalDocument.toFixed(2)}} each additional
                                </span>
                            </label>
                        </td>
                    </tr>
                    <tr class="text-start">
                        <td>
                            <span class="fw-bold p-0 text-decoration-underline" style="font-size:10px">Terms:&nbsp;</span>
                            <span class="p-0" style="font-size:10px;">{{ApostilleConfig.standardDeliveryTerms}}</span>
                        </td>
                        <td v-if="ApostilleConfig.offerExpressService">
                            <span class="fw-bold p-0 text-decoration-underline" style="font-size:10px;">Terms:&nbsp;</span>
                            <span class="p-0" style="font-size:10px;">{{ApostilleConfig.expressDeliveryTerms}}</span>
                        </td>
                    </tr>
                </table>

            </div>
        </div>
    </div>
</template>

<script>
   import { useEditorStore } from '/src/stores/EditorStore';
   import EventHub from '/src/Util/EventHub.js';
   import axios from '/src/components/NovaAxios.js';
   import { computed, ref, nextTick } from 'vue'
   import { toast } from 'vue3-toastify';

    export default {
        name: 'schedulerRON',
        components: {
        },
        props: {
        },
        data() {
            return {
                AddressError: '',
                Store: {}
            };
        },
        methods:
        {            
             OnStepActivated: async function(){
                 if(this.Store.Checkout.Cart.CurrentStep == 2){

                     if(!this.Store.Checkout.Cart.NumApostilleItems){
                         this.Store.Checkout.Cart.NumApostilleItems = 1;
                     }
                 }
             },
            OnCmdNext: async function () {
                if(this.Store.Checkout.Cart.CurrentStep != 2){
                    return;
                }

                var isAddressValid = false;
                const requiredFields = ['Name', 'Street1', 'City', 'State', 'Zip', 'Country'];
                const missingFields = requiredFields.filter(field => !this.Store.Checkout.Cart.ApostilleReturn[field]?.trim());

                if (missingFields.length > 0) {
                    isAddressValid = false;
                }
                else {
                    isAddressValid = true;
                }

                if (!isAddressValid) {
                    nextTick().then(() => {
                        this.AddressError = "Please enter all required address fields.";
                    });

                    toast.error("Please enter all required address fields.");
                    return;
                } else {
                    this.AddressError = '';
                }

                this.Store.SetCurrentStep((this.Store.Checkout.Cart.CurrentStep || 0) + 1)                
            }
        },
        computed:
        {
            ApostilleConfig: function () {
                if (this.Store && this.Store.TenantConfig && this.Store.TenantConfig.serviceConfigApostille) {
                    return this.Store.TenantConfig.serviceConfigApostille;
                }
                return {};
            },
          
            ApostilleCheckoutText: function () {
                var str = "Go To Checkout For $" + this.ApostilleTotal.toFixed(2);
                this.Store.Checkout.NextButton.Text = str;
                return str;
            },
            ApostilleTotal: function () { 
                var amount = 0

                if (this.Store.Checkout.Cart.ServiceSpeed == 0) {
                    amount = this.ApostilleConfig.basicFee + ((this.Store.Checkout.Cart.NumApostilleItems - 1) * this.ApostilleConfig.basicFeeAdditionalDocument);
                } else {
                    amount = this.ApostilleConfig.expeditedFee + ((this.Store.Checkout.Cart.NumApostilleItems - 1) * this.ApostilleConfig.expeditedFeeAdditionalDocument);
                }
    
                var str = "Go To Checkout For $" + amount.toFixed(2);
                this.Store.Checkout.NextButton.IsVisible = true;
                this.Store.Checkout.NextButton.Text = str;
                this.Store.Checkout.Cart.Price = amount;
                return amount;
            },
        },
        beforeMount: function () {

        },
        created() {
             this.Store = useEditorStore();
             EventHub.$on('OnCmdNext', this.OnCmdNext);
             EventHub.$on('OnStepActivated', this.OnStepActivated);
         },
         beforeUnmount() {
             EventHub.$off('OnStepActivated', this.OnStepActivated);
             EventHub.$off('OnCmdNext', this.OnCmdNext);
         },
    }
</script>

<style>
  
</style>